import { useEffect } from "react";
import Header from "../components/layout/Header";
import Hero from "../components/hero/Hero";
import About from "../components/about/About";
import Services from "../components/services/Services";
import Projects from "../components/projects/Projects";
import Partners from "../components/partners/Partners";
import WhyChoose from "../components/whychoose/WhyChoose";
import Downloads from "../components/downloads/Downloads";
import Contact from "../components/contact/Contact";
import Footer from "../components/layout/Footer";
import WhatsAppButton from "../components/layout/WhatsAppButton";
import { trackPageView, trackVisitor } from "../components/utils/analytics";

export default function Home() {
  useEffect(() => {
    trackVisitor("Home");
    trackPageView("Home");
  }, []);

  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Partners />
      <WhyChoose />
      <Downloads />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
}
